var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_843_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.34508 13.8507C7.94289 13.8507 7.60339 14.2937 7.60339 14.8175C7.60339 15.3417 7.94285 15.7847 8.34508 15.7847C8.74726 15.7847 9.08715 15.3417 9.08715 14.8175C9.08715 14.2937 8.74726 13.8507 8.34508 13.8507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.849 18.9636C14.4468 18.9636 14.1073 19.4066 14.1073 19.9309C14.1073 20.4546 14.4468 20.8976 14.849 20.8976C15.2512 20.8976 15.5911 20.4546 15.5911 19.9309C15.5911 19.4066 15.2512 18.9636 14.849 18.9636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0639 11.1308C12.5291 5.11787 12.8633 5.34754 12.3438 5.14572C11.6055 4.85284 10.7269 5.00598 10.1201 5.56423L4.07039 11.1308C3.39016 11.7565 3 12.6468 3 13.574V23.4315C3 24.5929 3.9402 25.5383 5.09563 25.5383H18.0382C19.1937 25.5383 20.1338 24.5929 20.1338 23.4315V13.574C20.1339 12.6468 19.7437 11.7565 19.0639 11.1308ZM10.9434 9.01763C10.9825 8.64303 11.3261 8.37701 11.7105 8.44916C12.0781 8.52581 12.2852 8.87859 12.2166 9.20712C12.1438 9.55715 11.8145 9.78011 11.4587 9.7133C11.1188 9.6424 10.9113 9.33362 10.9434 9.01763ZM6.31427 14.8176C6.31427 13.5736 7.22525 12.5617 8.34505 12.5617C9.46529 12.5617 10.3762 13.5736 10.3762 14.8176C10.3762 16.0615 9.46525 17.0738 8.34505 17.0738C7.22525 17.0738 6.31427 16.0615 6.31427 14.8176ZM10.0093 21.6779C9.55381 21.6779 9.23593 21.211 9.41545 20.7838L12.5531 13.3055C12.691 12.9772 13.0687 12.8225 13.397 12.9604C13.7253 13.0979 13.8796 13.4761 13.7421 13.8044L10.604 21.2826C10.5004 21.5293 10.2615 21.6779 10.0093 21.6779ZM14.849 22.1867C13.7292 22.1867 12.8182 21.1748 12.8182 19.9308C12.8182 18.6869 13.7292 17.6745 14.849 17.6745C15.9688 17.6745 16.8802 18.6869 16.8802 19.9308C16.8802 21.1748 15.9688 22.1867 14.849 22.1867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8382 18.2095C22.7396 12.1005 21.574 8.70386 21.5574 8.66528C21.1926 7.82051 20.4836 7.16352 19.6131 6.86317C19.5631 6.8462 19.8579 6.91778 15.1833 5.80872L19.9362 10.1821C20.8811 11.0509 21.423 12.2871 21.423 13.574V21.9272L23.7416 20.9346C24.7905 20.4808 25.2782 19.2627 24.8382 18.2095Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.7791,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupon);
export default __webpack_public_path__ + "static/media/cupon.a48cfe842f62c7c505fd31f4efb24b57.svg";
export { ForwardRef as ReactComponent };